module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0054.jpg?v=c299326c";